import {httpService} from "@/modules/common/services";

const baseRoute = '/business/accounts/v1';

const fetchAttributes = async () =>
  httpService.get(`${baseRoute}/attributes`, { new_api: true })
    .then((res) => res.data.attributes);

export default {
  fetchAttributes,
};
